import styled from '@emotion/styled';
import { mqUser } from 'utils/responsive';

const Title = styled.div`
    font-weight: 700;
    font-size: 22px;
    line-height: 65px;
    letter-spacing: 0%;
    color: var(--main-font-color);
    margin-bottom: 10px;

    ${mqUser('SP')} {
        line-height: 1.5;
        font-size: var(--font-x-large);
        margin-bottom: 20px;
    }
`;

interface Props {
    title: string;
}

/**
 * 画面のタイトル
 */
export const PageTitle: React.FC<Props> = ({ title }) => {
    return <Title>{title}</Title>;
};
